import { EditOutlined, EyeOutlined } from '@ant-design/icons'
import { Form as FormModel } from '@models/Form'
import { getForms, selectForms, setFormQuery } from '@store/FormReducer'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction, useSBRM } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { useAppDispatch, useAppSelector } from '@utils/hooks'
import { extractSortDataFromSorterResult } from '@utils/table/sorter'
import { Button, Flex, Space, TableColumnsType, TableProps } from 'antd'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const FormsPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const items = useAppSelector(selectForms())
  const { query, isLoading } = useAppSelector((state) => state.form)
  const { isOpen } = useSBRM()

  const columns: TableColumnsType<FormModel> = [
    {
      key: 'name',
      title: 'Nom',
      width: 300,
      render: (_, record) => record.name,
    },
    {
      key: 'actions',
      align: 'right',
      render: (_, record) => (
        <Space>
          {record.isLocked ? (
            <Button
              onClick={() => {
                navigate(record.id.toString())
              }}
              icon={<EyeOutlined />}
            />
          ) : (
            <>
              <Button
                onClick={() => {
                  navigate(record.id.toString())
                }}
                icon={<EditOutlined />}
              />
              <SBRM.Actions
                actions={[SBRMAction.Delete]}
                entity={Entity.form}
                entityId={record.id}
              />
            </>
          )}
        </Space>
      ),
    },
  ]

  const handleTableChange: TableProps<FormModel>['onChange'] = (
    pagination,
    filters,
    sorter
  ) => {
    const newQuery: TableParams = {
      pagination,
      filters,
      ...extractSortDataFromSorterResult(sorter),
    }
    dispatch(setFormQuery(newQuery))
    dispatch(getForms(newQuery))
  }

  useEffect(() => {
    dispatch(getForms(query))
  }, [dispatch, isOpen])

  return (
    <Flex vertical className="container-row">
      <PageTitle
        level={5}
        title="Formulaires"
        toolbar={
          <Button
            title="Create"
            type="primary"
            onClick={() => {
              navigate('create')
            }}
          >
            Ajouter
          </Button>
        }
      />
      <SBTable
        scroll={{ x: 600 }}
        columns={columns}
        dataSource={items}
        pagination={query.pagination}
        loading={isLoading}
        onChange={handleTableChange}
      />
    </Flex>
  )
}

export default FormsPage
